import { NavLink, Outlet } from "react-router-dom";
import {
  GitBranch, LayoutDashboard, Inbox, Send, Layers, Wand2,
  UserCheck, Clock8, FolderCog, History as HistoryIcon, ScrollText, Settings,
} from "lucide-react";

const TABS = [
  { to: "/workflow",             label: "Dashboard",        icon: LayoutDashboard, end: true, testid: "wae-tab-dashboard" },
  { to: "/workflow/inbox",       label: "My Inbox",         icon: Inbox,                     testid: "wae-tab-inbox" },
  { to: "/workflow/my-requests", label: "My Requests",      icon: Send,                      testid: "wae-tab-my" },
  { to: "/workflow/chains",      label: "Approval Chains",  icon: Layers,                    testid: "wae-tab-chains" },
  { to: "/workflow/designer",    label: "Designer",         icon: Wand2,                     testid: "wae-tab-designer" },
  { to: "/workflow/delegations", label: "Delegations",      icon: UserCheck,                 testid: "wae-tab-delegations" },
  { to: "/workflow/escalations", label: "Escalations",      icon: Clock8,                    testid: "wae-tab-escalations" },
  { to: "/workflow/templates",   label: "Templates",        icon: FolderCog,                 testid: "wae-tab-templates" },
  { to: "/workflow/history",     label: "History",          icon: HistoryIcon,               testid: "wae-tab-history" },
  { to: "/workflow/audit",       label: "Audit",            icon: ScrollText,                testid: "wae-tab-audit" },
  { to: "/workflow/settings",    label: "Settings",         icon: Settings,                  testid: "wae-tab-settings" },
];

export default function WAEShell() {
  return (
    <div className="space-y-6" data-testid="wae-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <GitBranch className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">
            Workflow &amp; Approval Engine
          </h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            Central approval orchestration · Delegations · Escalations · Auto-Approval · Configurable templates.
          </p>
        </div>
      </div>
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet/>
    </div>
  );
}
